import { Component, OnDestroy, OnInit } from '@angular/core';
import { CategoryModel, StorePageStore } from '@boxx/store-core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { skip, takeUntil } from 'rxjs/operators';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';

@Component({
  selector: 'app-categories-list',
  templateUrl: './categories-list.page.html',
  styleUrls: ['./categories-list.page.scss'],
})
export class CategoriesListCouponPage implements OnInit, OnDestroy {
  destroyed$ = new Subject<boolean>();
  isInView = true;

  loader: HTMLIonLoadingElement;

  translations: any;

  itemList: CategoryModel[] = [];
  searchResults: any[] = [];

  previousCategoriesOptions: any[];
  hasItemsselected: boolean = false;

  isFiltering = false;

  loading$: Observable<boolean>;

  constructor(
    private storePageStore: StorePageStore,
    private boxxUtils: BoxxUtilsService,
    private modalCtrl: ModalController,
    translate: TranslateService
  ) {
    translate
      .get(['ACTIONS', 'STORE_MODULE', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  ngOnInit() {
    this.handleLoading();
    this.handleSuccess();
    this.handleError();

    this.loadCategories();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ionViewWillEnter() {
    this.isInView = true;
  }

  ionViewDidLeave() {
    this.isInView = false;
  }

  loadCategories() {
    this.storePageStore.categoriesStore.data$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((categoryList) => {
        this.itemList = categoryList;
        this.searchResults = [];
        for(let i = 0; i < categoryList.length; i++){
          let isChecked = false;
          const catSel = this.previousCategoriesOptions.length > 0 ? this.previousCategoriesOptions.filter((item)=> (item.id === categoryList[i].id && item.checked)) : [];
          if(catSel.length > 0){
            isChecked = true;
          }
          this.searchResults.push({
            id: categoryList[i].id,
            name: categoryList[i].name,
            description: categoryList[i].description,
            productCount: categoryList[i].productCount,
            image: categoryList[i].image,
            checked: isChecked
          });
        }
      });

    this.storePageStore.categoriesStore.fetched$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((fetched) => {
        if (!fetched) {
          this.storePageStore.categoriesStore.fetch();
        }
      });
  }

  checkSelected(){
    this.hasItemsselected = false;
    for(let i = 0; i < this.searchResults.length; i++){
      if(this.searchResults[i].checked){
        this.hasItemsselected = true;
        break;
      }
    }
  }

  search(searchTerm: any) {
    this.searchResults = this.itemList;

    if (!searchTerm.detail.value) {
      return;
    }

    this.searchResults = this.searchResults.filter(
      (item) =>
        item.name
          .toLowerCase()
          .indexOf((searchTerm?.detail?.value || '').toLowerCase()) > -1
    );
  }

  close() {
    this.modalCtrl.dismiss();
  }

  getFirstLetter(name){
    return name.charAt(0).toUpperCase();
  }

  confirmDelete(id: number, slidingItem: any) {
    slidingItem.close();
    this.boxxUtils.showAlert({
      header: this.translations.ACTIONS.delete,
      message:
        this.translations.STORE_MODULE.categoriesItem_VIEW.CONFIRM
          .deleteMessage,
      buttons: [
        {
          text: this.translations.ACTIONS.cancel,
          cssClass: 'boxx-main-btn',
        },
        {
          text: this.translations.ACTIONS.delete,
          handler: () => this.storePageStore.categoriesStore.delete(id),
        },
      ],
    });
  }

  selectCategories(){
    const cats = this.searchResults.filter((item)=> item.checked);
    this.modalCtrl.dismiss({data: cats});
  }

  private handleLoading() {
    this.storePageStore.categoriesStore.loading$
      .pipe(skip(1), takeUntil(this.destroyed$))
      .subscribe(async (loading) => {
        setTimeout(async () => {
          this.boxxUtils.handleLoading(loading);
        }, 200);
      });
  }

  private handleSuccess() {
    this.storePageStore.categoriesStore.success$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(async (success) => {
        if (success && success.after === 'DELETE_CATEGORY') {
          this.boxxUtils.showToastSuccess({
            message: this.translations.SUCCESS.STORE.CATEGORIES[
              success.after.toLowerCase()
            ],
          });
        }
      });
  }

  private handleError() {
    this.storePageStore.categoriesStore.error$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(async (error) => {
        if (error) {
          this.boxxUtils.showToastError({
            message:
              this.translations.ERRORS.STORE.CATEGORIES[
                error.after.toLowerCase()
              ],
          });
        }
      });
  }
}
